const doc = [({"en":({"js":({"admin":({"steps":({"element_feedback_option":({"possible_answer":"Possible answer", "the_option_was_deleted":"The option was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;